/* eslint-disable no-console */
import React, { Component } from 'react';
import { Button } from 'antd';
import './error-boundary.less';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console
    console.error('ErrorBoundary caught an error:', error, errorInfo);

    // Store error details for display
    this.setState({
      error,
      errorInfo,
    });

    // Log to error reporting service (e.g., Sentry) if available
    if (process.env.NODE_ENV === 'production') {
      // Example: logErrorToService(error, errorInfo);
      // You can integrate with error tracking services here
    }
  }

  handleReset = () => {
    const { onReset } = this.props;

    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });

    // Call onReset callback if provided
    if (onReset) {
      onReset();
    }
  };

  // eslint-disable-next-line class-methods-use-this
  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { hasError, error, errorInfo } = this.state;
    const { children, fallback, showDetails = false } = this.props;

    if (hasError) {
      // Use custom fallback if provided
      if (fallback) {
        return fallback(error, errorInfo, this.handleReset);
      }

      // Default error UI
      return (
        <div className="error-boundary">
          <div className="error-boundary-content">
            <div className="error-boundary-icon" />
            <h2 className="error-boundary-title">Something went wrong</h2>
            <p className="error-boundary-message">
              We&apos;re sorry, but something unexpected happened. Please try
              again.
            </p>

            {showDetails && process.env.NODE_ENV === 'development' && error && (
              <div className="error-boundary-details">
                <details>
                  <summary>Error Details (Development Only)</summary>
                  <pre className="error-boundary-stack">
                    {error.toString()}
                    {errorInfo && errorInfo.componentStack}
                  </pre>
                </details>
              </div>
            )}

            <div className="error-boundary-actions">
              <Button type="primary" onClick={this.handleReset}>
                Try Again
              </Button>
              <Button onClick={this.handleReload}>Reload Page</Button>
            </div>
          </div>
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
